export const transform_child_data = (data)=>{


   const exm =  {
		"statusMR": {
			"result": "true",
			"date": "2024-10-10T06:17:19.349Z"
		},
		"groupId": "6603d5bf1773a2076d4049c6",
		"groupName": "Малятко",
		"groupNumber": "03.2024-2025",
		"_id": "660fa97187c060079ba23e85",
		"dateFrom": "2024-04-05T06:00:00.000Z",
		"tabelNumber": "975",
		"firstName": "Мирослава",
		"lastName": "Мирослава_ТЕСТ",
		"birthDate": "2022-02-21T00:00:00.000Z",
		"benefits": [
			{
				"_id": "660fa97187c060079ba23e86",
				"benefitId": "60e81561904ae40729056dc4",
				"documentIssueDate": null,
				"documentTo": null
			}
		],
		"placeType": "standart"
	}

    const {firstName, lastName, middleName, birthDate, birth, _id } = data;

const out = {
  fullName: [firstName, middleName, lastName].join(" "),
  fileNumber: '',
  id: _id,
  admissionDate: '08.06.2021',
  birthCertificateNumber: 'I-БК-696248',
  birthCertificateDate: '17.11.2022',
  residenceVerificationDate: '22.05.2024',
  healthCondition: 'Приклад захворювання',
  healthDocument: 'Назва документа',
  healthDocumentDate: '12.01.2022',
  healthDocumentNumber: 'AA-45968989-0000',
  healthDocumentIssuedBy: 'Семененко Тарас Ярославович',
  benefitDescription: 'Діти, яким встановлено інвалідність, пов\'язану з Чорнобильською катастрофою',
  benefitDocument: 'Назва документа',
  benefitDocumentDate: '12.01.2022',
  benefitDocumentNumber: 'AA-45698599-0000',
  benefitDocumentIssuedBy: 'Семененко Тарас Ярославович',
  motherName: '',
  motherPhone: '',
  motherEmail: '',
  motherIPN: '',
  motherCitizenship: 'Україна',
  fatherName: '',
  fatherPhone: '',
  fatherEmail: '',
  fatherIPN: '',
  fatherCitizenship: 'Україна',
  relatedPersons: [],
  isOrphan: 'Ні',
  isDisplaced: 'Ні',
  isDistanceLearning: 'Ні',
  isContactLost: 'Ні',
  foodType: 'Звичайне',
  history: [
    {
      date: '13.01.2024',
      event: 'Оформлена до садочку',
      kindergarten: 'N530',
      group: '03.2024 Малятко, перша молодша група — від 2-х до 3-х років',
      type: 'Повного дня'
    }
  ],
  accruals: [
    { month: 'Січень 2024', days: 20, rate: 100, debt: 0, amountDue: 2000 },
    { month: 'Лютий 2024', days: 18, rate: 100, debt: 200, amountDue: 1800 }
  ],
  payments: [
    { paymentDate: '15.01.2024', amount: 2000, paymentMethod: 'Картка', status: 'success' },
    { paymentDate: '12.02.2024', amount: 1800, paymentMethod: 'Готівка', status: 'success' }
  ],
  attendance: [
    { month: 'Січень 2024', daysInMonth: 31, attendanceDays: 20 },
    { month: 'Лютий 2024', daysInMonth: 29, attendanceDays: 18 }
  ],
  files: []
}
}

export const getFreeTabNumber = (groups) => {
        
        const getRandom = () => parseInt(Math.random() * 999).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping:false});

        const existsNumbers = [];

        let newNumber = '';

        for(let gr of groups){
            for(let ch of gr.children){
                existsNumbers.push( ch.smallNumber );
            }
        }

        for(;;){
            newNumber = getRandom();
            if(!existsNumbers.includes(newNumber)) break;
        }

        return newNumber;

}